import { envSlice } from "./UserProfile.redux";

export const { setEnvState } = envSlice.actions;